import { ref, markRaw } from 'vue';
import { defineStore }  from 'pinia';

export const useAppStore = defineStore('app', () => {

  const csrf         = markRaw({ ...(window.defaultCsrf || {}), ...(window.csrf || {}) });
  const translations = markRaw(window.translations || {});
  const locale       = ref(window._locale || 'en');

  const countries        = markRaw(window.countries        || []);
  const messengers       = markRaw(window.messengers       || []);
  const devices          = markRaw(window.devices          || []);
  const browsers         = markRaw(window.browsers         || []);
  const operatingSystems = markRaw(window.operatingSystems || []);

  return { translations, csrf, locale, countries, messengers, devices, browsers, operatingSystems };
});
